// extracted by mini-css-extract-plugin
export default {"heading":"CA-z","createAccount":"DA-z","disabled":"EA-z","copy":"FA-z","terms":"GA-z"};